import {createClient} from '@orion-js/graphql-client'
import url from './url'
import TwoFactorPromptProvider from './TwoFactorPromptProvider'
import fireEvent from 'App/helpers/globalEvents/fireEvent'
import logger from 'App/helpers/logger'

// use unique session key per project to avoid
// loging in and out every time you change projects
// in localhost
const sessionKey = 'rocket.session'

export default createClient({
  endpointURL: url,
  useSubscriptions: false,
  promptTwoFactorCode: TwoFactorPromptProvider.promptTwoFactor,
  saveSession(session) {
    localStorage.setItem(sessionKey, JSON.stringify(session, null, 2))
    fireEvent('saveSession', session)
  },
  getSession(session) {
    try {
      return JSON.parse(localStorage.getItem(sessionKey))
    } catch (e) {
      logger.error(e)
      return {}
    }
  }
})
